// فلاتر CSS لتحويل اللوجو إلى ألوان مختلفة حسب الثيم
export const logoFilters = {
  light: {
    filter: 'brightness(0) saturate(100%) invert(15%) sepia(100%) saturate(3000%) hue-rotate(180deg) brightness(0.7) contrast(1.5)',
    // يحول اللوجو إلى لون أزرق داكن للوضع الفاتح
  },
  dark: {
    filter: 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(1) contrast(1)',
    // يحول اللوجو إلى أبيض للوضع الداكن
  },
  highContrast: {
    filter: 'brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0) contrast(1000%)',
    // يحول اللوجو إلى أسود خالص للوضع عالي التباين
  }
};

// دالة للحصول على الفلتر المناسب حسب الثيم
export const getLogoFilter = (theme) => {
  return logoFilters[theme]?.filter || logoFilters.dark.filter;
}; 